/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_No_MatchInputs */

const en_cases_no_match = /** @type {(inputs: Cases_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No cases match these filters.`)
};

const pt_br2_cases_no_match = /** @type {(inputs: Cases_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum caso corresponde aos filtros.`)
};

/**
* | output |
* | --- |
* | "No cases match these filters." |
*
* @param {Cases_No_MatchInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_no_match = /** @type {((inputs?: Cases_No_MatchInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_No_MatchInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_no_match(inputs)
	return pt_br2_cases_no_match(inputs)
});